import * as React from 'react';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { GetVoidProyectoBusqueda, ProyectoBusqueda } from '../../interfaces/ProyectoBusqueda';
import { DataHistorialUser } from '../../interfaces/DataBsqProy';
import {format} from 'date-fns';
import { DetallesProyecto, getVoidDetallesProyecto } from '../../interfaces/DetallesProyecto';
import ProyectoService from '../../services/ProyectoService';
import { DetalleProyectoGeneralModal } from './DetalleProyectoGeneral';
import HideAndSeek from '../../ExitEden/HideAndSeek';

interface Column {
  id: 'code' | 'title' | 'responsable' | 'inicio' | 'fin' | 'estado' | 'opcions' | 'fchevento' | 'comentario' | 'accion';
  label: string;
  minWidth?: number;
  align?: 'right';
  format?: (value: number) => string;
}

const columns: readonly Column[] = [
  { id: 'code', label: 'Código', minWidth: 50},
  { id: 'title', label: 'Título', minWidth: 70},
  {
    id: 'accion',
    label: 'Acción',
    minWidth: 50,
  },
  {
    id: 'comentario',
    label: 'Comentario',
    minWidth: 70,
  },
  {
    id: 'fchevento',
    label: 'Fecha Evento',
    minWidth: 85,
  }
];

interface Data {
  name: string;
  code: string;
  population: number;
  size: number;
  density: number;
}

function createData(
  name: string,
  code: string,
  population: number,
  size: number,
): Data {
  const density = population / size;
  return { name, code, population, size, density };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

const proyectoService = new ProyectoService();
const hideAndSeek = new HideAndSeek();

export default function EventosHistorialTable(props: DataHistorialUser) {
  let history = useNavigate()
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(props.rowsPerPage[0]);
  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);
  const [modalData, setModalData] = React.useState<ProyectoBusqueda>(GetVoidProyectoBusqueda());
  const [detalleData, setDetalleData] = React.useState<DetallesProyecto>(getVoidDetallesProyecto());

  //#region Funciones 
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const goToNavigation = (site:string) =>{
    history(site)
  }
  const handleSearchDetalle = async (id:number) =>{
    try{
      await proyectoService.GetDetalleProyectoById(id,props.token)
              .then((data) => {
                  console.log(data);
                  setDetalleData(data.data);
              })
              .catch((error) => {
                console.error(error)
              });
    }catch(error){
      console.error('Error:',error);
    }
  };
  const handleOpenModal = async (data: ProyectoBusqueda) => {
    await handleSearchDetalle(data.idProyecto);
    setModalData(data);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  //#endregion
  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>

      <TableContainer sx={{ maxHeight: 600 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
            {columns.map((column) => (                
                <StyledTableCell 
                      style={{ minWidth: column.minWidth,zIndex:0 }}
                      key={column.id}
                      align={column.align}>
                  {column.label}
                  </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
          {/* <StyledTableRow key={'search-00'}>
                    <StyledTableCell component="th" scope="row">
                      codigo
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row">
                      titulo
                    </StyledTableCell>
                    <StyledTableCell align="left">accion</StyledTableCell>
                    <StyledTableCell align="left">comentario</StyledTableCell>
                    <StyledTableCell align="left"></StyledTableCell>
            </StyledTableRow> */}
            {props.data.length > 0 ? props.data
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <StyledTableRow key={row.evento.iddecinvproyectoevnt}>
                    <StyledTableCell component="th" scope="row">
                      {row.codigoProyecto}
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row">
                      {row.tituloProducto}
                    </StyledTableCell>
                    <StyledTableCell align="left">{row.evento.accion}</StyledTableCell>
                    <StyledTableCell align="left">{row.evento.comentario}</StyledTableCell>
                    <StyledTableCell align="left">{format(new Date(row.evento.fechaevnt),'dd/MMM/yyyy')}</StyledTableCell>
                  </StyledTableRow>
                );
              }):
              <StyledTableRow key={0}>
              <StyledTableCell component="th" scope="row"></StyledTableCell>
                    <StyledTableCell align="left">{'No hubo resultados'}</StyledTableCell>
                    <StyledTableCell align="left"></StyledTableCell>
                    <StyledTableCell align="left"></StyledTableCell>
            </StyledTableRow>
              }
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={props.rowsPerPage}
        component="div"
        count={props.data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <DetalleProyectoGeneralModal isOpen={isModalOpen} onClose={handleCloseModal} data={modalData} detalle={detalleData}/>
    </Paper>
  );
}